import { Alert, Popover, Snackbar } from "@mui/material";
import { StyledButton } from "components/common/Popover/styled";
import { Button } from "components/parts/Button/Button";
import { newColors } from "constants/newColors";
import { DisplayMonitor } from "pages/MonitorManagement/hook";
import { StyledClicpBoardPopoverInner } from "pages/MonitorManagement/styled";
import React, { ReactNode } from "react";
import { useHistory } from "react-router-dom";

type PopoverWithButtonProps = {
  buttonChildren: ReactNode;
  monitor: DisplayMonitor;
};

export const PopoverWithButton: React.FC<PopoverWithButtonProps> = (props) => {
  const { buttonChildren, monitor } = props;

  const history = useHistory();
  const [snackbarFlag, setSnackbarFlag] = React.useState(false);

  const onClickTextExport = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      await navigator.clipboard.readText();
      setSnackbarFlag(true);
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    }
  };

  const onClickUrlAndPinExport = async (url: string, pinCode: string) => {
    try {
      const exportArray = [
        ["URL:", url],
        ["PINコード:", pinCode],
      ];
      const clipboardText = exportArray
        .map((record) => record.join(" "))
        .join("\r\n");
      await navigator.clipboard.writeText(clipboardText);
      await navigator.clipboard.readText();
      setSnackbarFlag(true);
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    }
  };

  const onCloseSnackbar = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarFlag(false);
  };
  const [anchorElment, setAnchorElment] =
    React.useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElment(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElment(null);
  };
  const open = Boolean(anchorElment);
  const targetId = open ? "simple-popover" : undefined;
  return (
    <>
      <StyledButton aria-describedby={targetId} onClick={handleClick}>
        {buttonChildren}
      </StyledButton>
      <Popover
        id={targetId}
        open={open}
        anchorEl={anchorElment}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <StyledClicpBoardPopoverInner>
          <Button
            text="URL"
            onClick={() => {
              onClickTextExport(monitor.interviewUrl);
              handleClose();
            }}
            variant="primary"
          />
          <Button
            text="PINコード"
            onClick={() => {
              onClickTextExport(monitor.interviewPinCode);
              handleClose();
            }}
            variant="primary"
          />
          <Button
            text="URL/PINコード"
            onClick={() => {
              onClickUrlAndPinExport(
                monitor.interviewUrl,
                monitor.interviewPinCode
              );
              handleClose();
            }}
            variant="primary"
          />
        </StyledClicpBoardPopoverInner>
      </Popover>
      <Snackbar
        open={snackbarFlag}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={onCloseSnackbar}
      >
        <Alert
          variant="outlined"
          severity="success"
          color="warning"
          sx={{ width: "100%", backgroundColor: newColors.white }}
          onClose={onCloseSnackbar}
        >
          コピーが完了しました!
        </Alert>
      </Snackbar>
    </>
  );
};
